(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxManuallyAddGateway(
    $http, toastr, $filter, $timeout, RegexModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        networkDefinition: '=networkDefinition',
        callback: '&callback'
      },
      templateUrl: 'app/components/deployAssistant/defineNetwork/manuallyAddGateway/manuallyAddGateway.template.html',
      link: function(scope) {

        let regex = new RegexModel();

        scope.gateway = {
          ip: null,
          mac: null,
        };
        
        scope.runGatewayValidation = function () {
          scope.macAddressInvalid = true;
          scope.ipAddressInvalid = true;
          let gatewayIsValid = false;

          let mac = angular.copy(scope.gateway.mac);
          let ip = angular.copy(scope.gateway.ip);

          if ((mac && mac === '*') || (mac && regex.macRegex().test(mac))) {
            scope.macAddressInvalid = false;
          } else if (!mac) {
            scope.macAddressInvalid = false;
          } else {
            scope.macAddressInvalid = true;
          }
          
          if (ip && regex.ipRegex().test(ip)) {
            scope.ipAddressInvalid = false;
          } else if (!ip) {
            scope.ipAddressInvalid = false;
          } else {
            scope.ipAddressInvalid = true;
          }

          if (!scope.macAddressInvalid && !scope.ipAddressInvalid && ip && mac) {
            gatewayIsValid = true;
          } else {
            gatewayIsValid = false;
          }

          let manualGateway = {
            gwIp: ip,
            gwMac: mac,
            valid: gatewayIsValid
          }
          scope.networkDefinition.setGateway(manualGateway);
        }

        function cleanupGateway (mac) { // REMEMBER THIS IN THE SAVE DIALOG
          if (mac === '*') {
            return mac;
          } else {
            return mac.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
          }
        }


      }
    };
  }

  pxManuallyAddGateway.$inject = ['$http', 'toastr', '$filter', '$timeout', 'RegexModel'];

  angular
    .module('printix-admin')
    .directive('pxManuallyAddGateway', pxManuallyAddGateway);

})();
